<template>
  <section class="its-time">

    <div class="its-time__container">
      <div class="its-time__title title title_h2 fadeInBottom">It’s time to...</div>
      <div class="its-time-slider swiper fadeInLeft2">
        <div class="its-time-slider__wrapper swiper-wrapper">

          <div v-for= "(item, index) in resultNews" :key = "index" class="its-time-slider__slide swiper-slide" @click="redirect(item.DETAIL_PAGE_URL)">
            <div class="its-time-slider__label its-time-slider__label_book"><img :src="item.ICON_SECTION" alt="alt"><span>{{item.SECTION}}</span>
            </div>
            <picture >

              <img class="its-time-slider__poster" :src="item.IMAGE" alt="alt">
            </picture>
            <video class="its-time-slider__video" :src="item.VIDEO" playsinline data-play-hover muted></video>
            <div class="its-time-slider__info">
              <p class="its-time-slider__description">{{item.NAME}}</p>
              <time class="its-time-slider__date">{{item.DATE}}</time>
            </div>
          </div>


          <a class="its-time-slider__slide its-time-slider__slide_last swiper-slide" href="/its-time-to/">
            <div class="its-time-slider__info">
              <svg class="i-arrow-curved" aria-hidden="true">
                <use xlink:href="./icons/icons.svg#svg-arrow-curved"></use>
              </svg>
              <div>Смотреть все новости</div>
            </div></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {

  name : "ItsTimeBlock",
  props: {
    news :
        {
          type: Array,
          required: true
        },
    theme:
        {
          type: String,
          required: true
        }
  },


  watch: {
    resultNews: function()
      {
        //console.log('123');
        //window.initUI();
      }
  },

  // mounted()
  //   {
  //     window.initUI();
  //
  //   },
  computed: {
    resultNews() {
      return this.news.filter(item => (item.THEME[0] === this.theme || item.THEME[1] === this.theme ));
      //return localStorage.getItem('color-scheme');
    },

  },
  methods: {
    redirect(url)
      {
        window.location.href = url;
      }
  }

};
</script>

<style scoped>

</style>